module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "奖励类型",
      "placeholder": "请选择积分奖励",
      "rules": [{
        required: true,
        message: '请选择类型'
      }],
      "readonly": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.showTypeSelect
    },
    model: {
      value: (_vm.formData.type_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type_name", $$v)
      },
      expression: "formData.type_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "内容描述",
      "placeholder": "请输入详细的描述",
      "input-align": "right",
      "rules": [{
        required: true,
        message: '请输输入描述'
      }]
    },
    model: {
      value: (_vm.formData.note),
      callback: function($$v) {
        _vm.$set(_vm.formData, "note", $$v)
      },
      expression: "formData.note"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "title": "相关图片"
    }
  }), _vm._v(" "), _c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pics,
      "limit": 9,
      "name": 'pics'
    },
    on: {
      "imageListChange": _vm.imageListChange
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0",
      "color": "#1989fa"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_vm._v("全国啦啦操星级俱乐部积分制度.doc下载>>")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交申请")])], 1)], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.selectShow),
      callback: function($$v) {
        _vm.selectShow = $$v
      },
      expression: "selectShow"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "标题",
      "columns": _vm.columns
    },
    on: {
      "cancel": _vm.onCancel,
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05de29fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubScoreApply.vue
// module id = 2166
// module chunks = 0